var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAccountMore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    fill: "none",
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4D4D4D",
    fillRule: "evenodd",
    d: "M1.342 14C1.342 7.02 7.019 1.342 14 1.342 20.98 1.342 26.66 7.019 26.66 14c0 6.98-5.678 12.658-12.659 12.658-6.98 0-12.658-5.677-12.658-12.658zM14 3.325C8.115 3.325 3.325 8.115 3.325 14c0 5.885 4.79 10.675 10.675 10.675 5.885 0 10.675-4.79 10.675-10.675 0-5.885-4.79-10.675-10.675-10.675z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#4D4D4D",
    fillRule: "evenodd",
    d: "M8.167 13.416c-.322 0-.583.262-.583.584 0 .322.261.583.583.583.322 0 .583-.261.583-.583 0-.322-.261-.584-.583-.584zM5.834 14c0-1.288 1.045-2.334 2.333-2.334 1.288 0 2.333 1.046 2.333 2.334s-1.045 2.333-2.333 2.333c-1.288 0-2.333-1.045-2.333-2.333zM14 13.416c-.322 0-.583.262-.583.584 0 .322.261.583.583.583.322 0 .584-.261.584-.583 0-.322-.262-.584-.584-.584zM11.667 14c0-1.288 1.045-2.334 2.333-2.334 1.288 0 2.334 1.046 2.334 2.334S15.288 16.333 14 16.333 11.667 15.288 11.667 14zm8.167-.584c-.322 0-.584.262-.584.584 0 .322.262.583.584.583.321 0 .583-.261.583-.583 0-.322-.262-.584-.584-.584zM17.5 14c0-1.288 1.045-2.334 2.334-2.334 1.288 0 2.333 1.046 2.333 2.334s-1.045 2.333-2.334 2.333c-1.288 0-2.333-1.045-2.333-2.333z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountMore);
export default __webpack_public_path__ + "static/media/account-more.d2867b4619254c240e591dda50f57830.svg";
export { ForwardRef as ReactComponent };